import { ReactComponent as PlayButtonWhite } from "../../../../shared/Svg/play-circle-icon-small.svg";
import "./styles.scss";
import { useSelector, useDispatch } from "react-redux";
import hv_player_api from "../../../../../api/hv_player_api";
import { playMedium } from "../../../../../api/media";
import { useEffect, useRef, useState } from "react";
import actions from "../../../../../redux/actions";

export default ({ className, medium, onClick }) => {
  const videoRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(true);

  const state = useSelector(state => state);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.setPause({videoRef : videoRef , url : medium.url}))
    //Check here if audio already started someone then stope video
    if (state.playing) {
      videoRef.current.pause();
    }
  }, [state.playing]);

  const markPlay = () => {
    //Check here if someone start video then stope audio
    dispatch(actions.setPlaying(false))
    dispatch(actions.setPlay({videoRef : videoRef , url : medium.url}))
    setShowOverlay(false);
    playMedium(medium.id);
    videoRef.current.play(); // Start video
  };

  const onVideoPause = () => {
    setShowOverlay(true);
  };

  const handlePress = () => {
    const itemSelectedValue = Object.assign({},state.videoPlaying);
    Object.keys(itemSelectedValue).forEach((item, index) => {
        if(itemSelectedValue[item].paused){
          itemSelectedValue[item].vRef.current.pause();
        }
    })
  }
  
  return (
    <section className="timeline-video-container" onClick={markPlay}>
      {showOverlay && (
        <div className="timeline-video-overlay">
          <PlayButtonWhite />
        </div>
      )}
      <video
        ref={videoRef}
        className={`timeline-video ${className}`}
        src={`${medium.url}#t=0.01`}
        alt={medium.title}
        onPlay={markPlay}
        onPause={onVideoPause}
        controls={!showOverlay}
        //controls={state.videoPlaying}
        loop
        muted
        onClick={handlePress}
      />
    </section>
  );
};
